'use strict';
var scrollbeforePageloadTracked = false;
window.actionTrackings = window.actionTrackings || [];
window.addEventListener('scroll', function () {
    if (scrollbeforePageloadTracked) {
        return;
    }
    scrollbeforePageloadTracked = true;
    window.actionTrackings.push({
        acTrAc: 'scrolled_before_pageload',
        acTrLa: document.readyState
    });
});
